export default "__VITE_ASSET__DBL_GCvI__"